import L from 'leaflet'; 
import {useRef, useEffect, useState} from 'react';
import Loader from '@/components/loading_animation'
import {scalePolygon, shiftPolygon, calculateCentroid} from '@/lib/map_functions'

const clickState = (feature, layer, searchState, setActiveState) => {
 layer.on('click', (l) => {
        let search = {} 
        if (feature.properties.STUSPS) {
          setActiveState(layer._leaflet_id)
          searchState.addValueAtKey('q[state_eq]', feature.properties.STUSPS)
        }
        else {
          search.fips = feature.properties.GEOID;
        }
  }

 )
  layer.on('mouseover', (l) => {
    l.target.getElement().classList.add('lexcms-map-hovered-geo-feature')
 })
  layer.on('mouseout', (l) => {
   l.target.getElement().classList.remove('lexcms-map-hovered-geo-feature')
 })

}

const getBoundsForMap =  (map) => {
 if (map === 'CAN') {
   return L.latLngBounds(
     L.latLng(42, -53), //Southwest
     L.latLng(83, -141)  //Northeast
   )
 }
  else {
  return L.latLngBounds(
      L.latLng(49.3457868, -124.7844079), //Southwest
      L.latLng(24.7433195, -66.9513812)  //Northeast
    )
  }

}
const mapSettings = (map ) => {
    let minZoom;
    let initialZoom;
    if (map === 'CAN') {
      minZoom = 3;
      initialZoom = 3.5;
    }
    else {
      minZoom = 4;
      initialZoom = 4.5;
    }
    return [minZoom, initialZoom]
  }

export default function InteractiveMap({searchState, currentMap, reset}) {

  const mapRef =  useRef(null);
  const map = useRef(null);
  const mapLayerRef = useRef(new L.LayerGroup() )
  const [mapLoaded, setMapLoaded] = useState(false);
  const [mapDataLoaded, setMapDataLoaded] = useState(false);
  const [activeState, setActiveState] = useState(null);
  const [apiResponses, setApiResponses]  = useState({}) 

  
  const getMapData = async ()=> { return await  fetch(`/lex-api/map_data/all.json?map=${currentMap }`)
                                                      .then((res) => {setMapDataLoaded(true)
                                                                    return  res.json()})
                                          } 

 
  useEffect(async () => {
    if (map.current) {
      map.current.off();
      map.current.remove();
      mapLayerRef.current =  new L.LayerGroup()
    }
    let maxBounds =  getBoundsForMap(currentMap)
    let [minZoom, initialZoom] = mapSettings(currentMap )

    map.current = L.map(mapRef.current, {
      zoomControl: true, 
      maxBounds: maxBounds,
      scrollWheelZoom: false,
      doubleClickZoom: true,
      minZoom: minZoom,
      touchZoom: 'center',
      zoomSnap: 0.25,
      attributionControl: false
    }).fitBounds(maxBounds )
    map.current.setView(maxBounds.getCenter(), initialZoom)

    map.current.once('focus', function() { map.current.scrollWheelZoom.enable(); });
    map.current.whenReady(() => setMapLoaded(true ) )


   const territoryLayer = new L.LayerGroup();
   const addedLayers =  []
   const initialSearch = searchState.search  && searchState.search['q[state_eq]']
    
   let stateValues= {features: []} 
   if (apiResponses[currentMap]){ 
     stateValues = apiResponses[currentMap]
    }
    else{
     let resp = await  getMapData()
     stateValues = resp
    }
    setApiResponses((oldState) => ({...oldState, [currentMap]: JSON.parse(JSON.stringify(stateValues))}) )
    stateValues.features.forEach((d, i) => {
      if (d.properties.NAME === 'Alaska') {
        let shifted  =  shiftPolygon(d.geometry.coordinates, 30, -32);
        d.geometry.coordinates =  scalePolygon(shifted, 0.2) 
      }

      if (d.properties.NAME === 'Hawaii') {
        let shifted  =  shiftPolygon(d.geometry.coordinates, 48, 6);
        d.geometry.coordinates =  scalePolygon(shifted, 0.9) 
      }
      if (d.properties.NAME === 'Puerto Rico') {
        let shifted  =  shiftPolygon(d.geometry.coordinates, -10, 4);
        d.geometry.coordinates =  scalePolygon(shifted, 1.2)
      }

        mapLayerRef.current.addLayer(L.geoJSON(d, {onEachFeature: ((feature, layer) => clickState(feature, layer, searchState, setActiveState)),style: function(feature){ 
        switch(feature.properties.STUSPS === initialSearch) {
          case true: return {className: 'lexcms-map-geo-feature lexcms-map-active-geo-feature' } 
          default:  return {className: 'lexcms-map-geo-feature'}
        }
        }
      })
      )
    })
    addedLayers.forEach((d, i) => {
     territoryLayer.addLayer(d)
    })
    mapLayerRef.current.addTo(map.current); 
    territoryLayer.addTo(map.current)

   }, [currentMap])

 useEffect(()=> {
   let searchedState = searchState.search && searchState.search['q[state_eq]']  
   if (searchedState) {
     mapLayerRef.current.eachLayer((d, i) => {
       let geo = Object.values(d._layers)[0]
       if (geo?.feature?.properties?.STUSPS == searchedState) {
         setActiveState(Object.keys(d._layers)[0])
         return;
       }

     })
   }

   else {
     if (activeState) {
       setActiveState('');
       mapLayerRef.current?.eachLayer((d, i) => { 
         Object.values(d._layers)[0]?.getElement().classList?.remove('lexcms-map-active-geo-feature')

       })
     }
   }

   }, [searchState.search])

  useEffect(() => {
   let maxBounds =  getBoundsForMap(currentMap)
   let [minZoom, initialZoom] = mapSettings(currentMap )
    map.current.setView(maxBounds.getCenter(), initialZoom)

  }, [reset])
 
  useEffect(()=> {
    if (mapLayerRef.current && activeState) {
      mapLayerRef.current.eachLayer((d, i) => {
        if (d._layers[activeState]) {
          d._layers[activeState].getElement().classList.add('lexcms-map-active-geo-feature') 
        }
        else {
          Object.values(d._layers)[0]?.getElement().classList?.remove('lexcms-map-active-geo-feature')
        }
      })
    }
  }, [activeState])
  
  return (<div className='lexcms-interactive-map-container' ref={mapRef}>
           {!mapLoaded || !mapDataLoaded &&
            <Loader /> 
           }
        </div>); 

}
